<template>
  <div class="skillBar microskillSidebar endMeeting misc phase pane">
    <div class="endSkill">
      <div class="info">
        <h2 class="sidebarTitle">Meeting finished<strong>&hellip;</strong></h2>
        <p>Your meeting has now finished and this space gives you 30 seconds to say goodbye to your colleagues. See you again soon!</p>
      </div>
      <timer-responsive class="timerHolder" />
      <microskill-sidebar-buttons key="buttons" />
    </div>
  </div>
</template>

<script setup>
import TimerResponsive from '@/components/TimerResponsive.vue';
import MicroskillSidebarButtons from '@/components/MicroskillSidebarButtons';
</script>
<style lang="scss" scoped>
.skillBar {
  flex-direction: column;
  position: absolute;
  top: 0;
  bottom: 0;
  left: -1px;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: rem(83px);
  z-index: 5;
  width: rem($sidebar-width);
  @include no-scrollbars;
}
.endSkill {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto minmax(#{rem(170px)}, 1fr) auto;
  padding-bottom: rem(28px);
  .info {
    h2 {
      margin: rem(94px) rem(34px) rem(20px) rem(34px);
      //font-weight: bold;
    }
    p {
      margin: rem(20px) rem(34px) 0 rem(34px);
    }
  }
  .phaseButtonContainer {
    margin: rem(20px) rem(34px) 0 rem(34px);
  }
  .timerHolder {
    margin: 1em rem(34px) 1em rem(34px);
    //   margin: auto 0;
    //   display: flex;
    //   flex-direction: column;
    //   justify-content: center;
    //   align-items: center;
  }
  :deep(.timerHolder) {
    --timer-bar: var(--c__accent);
  }
}
</style>
